import { useAppNavigation } from '@euler/app/components/AppNavigationProvider';
import { FeatureNotEnabledView } from '@euler/components/entitlements/FeatureNotEnabledView';
import { useApdmCouponRedemption } from '@euler/functions/apdm/useApdmCouponRedemption';
import { canRedeemApdmCoupons } from '@euler/functions/apdmAccess';
import { useStoreFeature } from '@euler/functions/entitlements/useStoreFeature';
import { useUserProfileInfo } from '@euler/functions/user/useUserProfileInfo';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { StoreFeature } from '@euler/model/enum';
import { usePersistFn } from '@euler/utils/hooks';
import { useEffect } from 'react';
import { Platform, Text } from 'react-native';
import { ApdmCouponRedemptionWorkspace } from './ApdmCouponRedemptionWorkspace';

function RedemptionContent({
  storeId,
  code,
}: {
  storeId: number;
  code?: string;
}) {
  const workspace = useApdmCouponRedemption(storeId);
  const navigation = useAppNavigation();
  const load = usePersistFn(workspace.actions.load);
  // A code scanned elsewhere (扫一扫) is read on arrival; it runs after
  // the workspace resets for the store, so the read is not wiped.
  useEffect(() => {
    if (code) void load(code);
  }, [code, load]);
  return (
    <ApdmCouponRedemptionWorkspace
      workspace={workspace}
      onScan={
        // Web has no camera: the page offers the paste field instead.
        Platform.OS === 'web'
          ? undefined
          : () =>
              navigation.navigate('_qrcodeScan', {
                title: '扫描客户优惠券',
                onScan: value => {
                  void load(value);
                },
              })
      }
    />
  );
}
export const ApdmCouponRedemptionPage = wrapNavigatorScreen(
  ({ code }: { code?: string }) => {
    const profile = useUserProfileInfo();
    const apdm = useStoreFeature(StoreFeature.Apdm);
    const navigation = useAppNavigation();
    useEffect(() => {
      navigation.setOptions({ title: '优惠券核销' });
    }, [navigation]);
    if (!apdm.enabled)
      return <FeatureNotEnabledView feature={StoreFeature.Apdm} />;
    if (!profile?.user.enabled)
      return <Text>当前门店服务不可用，或账号不可用。</Text>;
    if (!canRedeemApdmCoupons(profile))
      return <Text>只有店长、服务顾问和营销负责人可以核销优惠券。</Text>;
    return (
      <RedemptionContent
        key={profile.store.id}
        storeId={profile.store.id}
        code={code}
      />
    );
  },
);
